t = require('app/scripts/views/internal/teacup-with-helpers')('jsw_crossflow_popover')

module.exports = t.renderable ->
  t.div '.jsw-crossflow-popover-message-container.arrow', ->
    t.a '.js-close-orientation.pop-over-header-close-btn.close-invitee-orientation.icon-sm.icon-close', { href: '#' }

    t.h1 =>
      t.format 'create-powerful-workflows'

    t.div ->
      t.div '.orientation-header', ->
        t.div '.board-header-facepile.invitee-orientation-facepile.js-invitee-orientation-facepile'

      t.div '.invitee-orientation-text.u-clearfix', ->
        t.img '.jsw-crossflow-popover-main-image',
          src: require('resources/images/jsw-crossflow/intercom.png')
        t.p '.jsw-crossflow-popover-content', ->
          t.format 'keep-everything-you-love-about-trello'
    t.button '.button.primary.jsw-crossflow-popover-button', =>
      t.format 'learn-more-about-jira-software'

  t.div '.jsw-crossflow-popover-avatar-container', ->
    t.img '.jsw-crossflow-popover-avatar',
      src: require('resources/images/jsw-crossflow/chorizo.svg')
